const LiveSearch = () => {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.classList.contains('relevanssi-live-search-results')) {
                        const classObserver = new MutationObserver(() => {
                            const body = document.querySelector('body');
                            const overlay = document.querySelector('.knowledge-base-search__overlay');
                            const input = document.querySelector('.knowledge-base-search__input');

                            if (!overlay) return;

                            if (node.classList.contains('relevanssi-live-search-results-showing')) {
                                overlay.classList.add('knowledge-base-search__overlay--active');
                                input.classList.add('knowledge-base-search__input--active');
                                body.classList.add('body--no-scroll');

                            } else {
                                overlay.classList.remove('knowledge-base-search__overlay--active');
                                input.classList.remove('knowledge-base-search__input--active');
                                body.classList.remove('body--no-scroll');
                            }
                        });

                        classObserver.observe(node, {
                            attributes: true,
                            attributeFilter: ['class'],
                        });

                        observer.disconnect();
                    }
                });
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

export default LiveSearch;
